import { render, staticRenderFns } from "./ContentTemplate.vue?vue&type=template&id=0ec8fe30"
import script from "./ContentTemplate.vue?vue&type=script&lang=js"
export * from "./ContentTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec8fe30')) {
      api.createRecord('0ec8fe30', component.options)
    } else {
      api.reload('0ec8fe30', component.options)
    }
    module.hot.accept("./ContentTemplate.vue?vue&type=template&id=0ec8fe30", function () {
      api.rerender('0ec8fe30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/dashboard/pdp-tabs/ContentTemplate.vue"
export default component.exports